import { ProjectModel } from 'src/store/state/projects';

export const findMostCommonlyUsedNamespace = (
  projectModel: ProjectModel
): string => {
  const databaseNamespaces = projectModel.databaseNamespaces || {};
  const namespaceIris = Object.values(databaseNamespaces).sort(
    // sort longest strings first, so that we are greedy and match the
    // correct namespaec with startsWith() below
    (a, b) => b.length - a.length
  );

  const usages = new Map<string, number>();
  const checkIri = (iri: string) => {
    // eslint-disable-next-line no-restricted-syntax
    for (const namespaceIri of namespaceIris) {
      if (iri.startsWith(namespaceIri)) {
        usages.set(namespaceIri, (usages.get(namespaceIri) || 0) + 1);
        break;
      }
    }
  };
  Object.values({
    ...projectModel.classes,
    ...projectModel.properties,
  }).forEach(({ iri }) => {
    checkIri(iri);
  });

  let mostUsed = '';
  [...usages.entries()].forEach(([namespace, count]) => {
    if (count && count > (usages.get(mostUsed) || 0)) {
      mostUsed = namespace;
    }
  });
  return mostUsed;
};
